import { render, staticRenderFns } from "./ResourceUploader.vue?vue&type=template&id=2aaecad9&scoped=true"
import script from "./ResourceUploader.vue?vue&type=script&lang=ts"
export * from "./ResourceUploader.vue?vue&type=script&lang=ts"
import style0 from "./ResourceUploader.vue?vue&type=style&index=0&id=2aaecad9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaecad9",
  null
  
)

export default component.exports